import React, { useState, useContext, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import BoxInfo from './boxInfo';
import BoxTruckRepresentative from './boxTruckRepresentative';
import { toast } from 'react-hot-toast';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import Checkbox from '@mui/material/Checkbox';
import DefaultModal from '../Utils/DefaultModal';
import ModalTransferRepresentative from './modalTransferRepresentative';
import { RepresentativeContext } from './distributionR';
import { externalComponent } from '../AppRoutes';
import SendBoxRepresentative from './sendBoxRepresentative';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModalText from './modalText';
import ColorButton from '../Buttons/ColorButton';
import Tooltip from '@mui/material/Tooltip';
import { api } from '../../services/api';
import { updateCodproInfo, checkcam, deletecam } from './functionsCore';
import MessageSend from './messageSend';
import DispbksBox from './disbksBox';

const DatagridRepresentative = ({ trucks_number, index, lines, table, m3, peso, envio, truck_size }) => {

  const { state, setState } = useContext(RepresentativeContext)
  const { setLoader } = useContext(externalComponent)
  const [modalStatus, setModalState] = useState(false)
  const [rowToTransfer, setRowToTransfer] = useState("")
  const [modalDelete, setModalDelete] = useState(false)
  const [rowToDelete, setRowToDelete] = useState("")

  const transferFunc = (row) => {
    let tables = state.data

    if (tables.length > 1) {
      setRowToTransfer(row)
      setModalState(true)
    } else {
      toast.error('Não há caminhões para transferência.')
    }

  }


  const closeModal = () => {
    setModalState(false)
  }

  const closeModalDelete = () => {
    setModalDelete(false)
  }

  const deleteRow = (row) => {
    setRowToDelete(row)
    setModalDelete(true)
  }

  const removeSugestionRedundant = (codpro) => {
    if (state.sugestions[codpro]) {

      if (state.sugestions[codpro][table].alter) {

        delete state.sugestions[codpro][table].check;
        state.sugestions[codpro][table].type = "alter"

      } else if (state.sugestions[codpro][table].add) {
        delete state.sugestions[codpro][table].check;
        state.sugestions[codpro][table].type = "add"
      }
      else {

        delete state.sugestions[codpro][table];

      }

      if (Object.keys(state.sugestions[codpro]).length === 0) {
        delete state.sugestions[codpro];
      }
    }
  }

  const changeChecked = (e, row) => {
    const checked = e.target.checked
    const rowId = row.id
    const codpro = row.codpro

    let checkRowValue = 0
    try {
      if (state.sugestions[codpro][table].row.check_lock) {
        checkRowValue = convertCheckedValue(state.sugestions[codpro][table].row.check_lock)
      }


    } catch (error) {
      setState({ bksChange: !state.bksChange })
    }

    if (checkRowValue === checked) {
      removeSugestionRedundant(codpro)
    } else {
      checkcam(state.sugestions, codpro, checked, table, row)
    }


    setState({ sugestions: state.sugestions })

    for (const each of state.data) {

      if (each[table]) {
        const lines = each[table].lines

        for (const line of lines) {

          if (line.id === rowId) {
            line['checked'] = String(checked)
          }

        }
      }

    }

  }

  const confirmDelete = () => {

    for (const each of state.data) {

      if (each[table]) {
        const lines = each[table]['lines']
        const filteredLines = lines.filter(item => item.codpro !== rowToDelete.codpro);
        each[table]['lines'] = filteredLines

      }
    }

    setState({ state: state.data })
    deletecam(state.sugestions, rowToDelete.codpro, table, rowToDelete)
    closeModalDelete()
  }

  const buttonConfirmDelete = () => {
    return (
      <Box>
        <ColorButton onClick={confirmDelete} >Sim </ColorButton>
      </Box>
    )
  }

  const convertCheckedValue = (value) => {
    if (value === 'true') {
      return true
    } else {
      return false
    }
  }

  const columnsMain = [

    {
      field: 'aro',
      headerName: 'Aro',
      flex: 0.4,
      renderCell: ({ value }) => (
        <Box sx={{ padding: '0px 10px', fontWeight: 'bold' }}>
          {value}
        </Box>
      )
    },
    {
      field: 'medida',
      headerName: 'Medida',
      flex: 0.6,
      renderCell: ({ value }) => (
        <Box sx={{ padding: '0px 10px', fontWeight: 'bold' }}>
          {value}
        </Box>
      )
    },
    {
      field: 'codpro',
      headerName: 'Codpro',
      flex: 0.4,
      renderCell: ({ value }) => (
        <Box sx={{ padding: '0px 10px' }}>
          {value}
        </Box>
      )
    },
    {
      field: 'descr',
      headerName: 'Descr',
      flex: 1.5,
      renderCell: ({ value }) => (
        <Box sx={{ padding: '0px 10px' }}>
          {value}
        </Box>
      )
    },
    {
      field: 'peso',
      headerName: 'Peso',
      flex: 0.4,
      renderCell: ({ value }) => (
        <Box sx={{ padding: '0px 22px' }}>
          {value}
        </Box>
      )
    },
    {
      field: 'm3',
      headerName: 'M3',
      flex: 0.4,
      renderCell: ({ value }) => (
        <Box sx={{ padding: '0px 10px' }}>
          {value}
        </Box>
      )
    },
    {
      field: `${state.branchName}`,
      headerName: `${state.branchName}`,
      flex: 0.3,
      renderCell: ({ value }) => (
        <Box className='est-tables' sx={{ padding: '0px 10px', fontWeight: 'bold' }}>
          {value}
        </Box>
      )
    },
    {
      field: `disp${state.branch}`,
      headerName: `Disp ${state.branch.toUpperCase()}`,
      flex: 0.3,
      renderCell: ({ value }) => (
        <Box className='disp-tables' sx={{ padding: '0px 10px', fontWeight: 'bold' }}>
          {value}
        </Box>
      )
    },
    {
      field: 'dispbks',
      headerName: 'BKS Disp',
      flex: 0.3,
      renderCell: ({ value, row }) => (
        <Box className='dep-bks' sx={{ padding: '0px 10px' }}>
          <DispbksBox bks={value} cargo={row.cargo} state={state} lock={row.cargo} />
        </Box>
      )
    },
    {
      field: 'cargo',
      headerName: 'Envio',
      flex: 0.5,
      renderCell: (params) => (

        <Box sx={{ padding: '0px 10px' }}>
          <SendBoxRepresentative envio={params.row.cargo} codpro={params.row.codpro}
            table={table} aro={params.row.aro} medida={params.row.medida} cargo={params.row.cargo}
            row={params.row}
          />
        </Box>
      )
    }
    ,
    {
      field: 'acoes',
      headerName: 'Ações',
      renderCell: (params) => (
        <Box>
          <Tooltip title="Transfere o pneu para outro caminhão">
            <ImportExportIcon className='actionIcon' sx={{ fontSize: '1.3rem' }} onClick={() => transferFunc(params.row)} />
          </Tooltip>

          <Tooltip title="Prioriza esse pneu no caminhão">
            <Checkbox checked={convertCheckedValue(params.row.checked)} onClick={(event) => changeChecked(event, params.row)} />
          </Tooltip>

          <Tooltip title="Deleta o pneu do caminhão">
            <DeleteForeverIcon onClick={() => deleteRow(params.row)} className='actionIcon' sx={{ fontSize: '1.3rem' }} />
          </Tooltip>
        </Box>
      )
    }
  ]

  const getCodproInfos = async () => {

    const branch = state.branch
    const codpros = lines.map(each => each['codpro'])

    const body = {
      "branch": branch,
      "codpros": codpros
    }

    setLoader(true)
    const res = await api.post(`/distribution_elevor/codproinfo/`, body)
    if (res.status === 200) {
      const data = res.data
      updateCodproInfo(data, lines)
    }
    setLoader(false)
    setState({ bksChange: !state.bksChange })

  }

  useEffect(() => {
    getCodproInfos()

    for (const each of state.data) {

      if (each[table]) {
        const lines = each[table].lines

        for (const line of lines) {

          line['check_lock'] = line.checked

        }
      }

    }



  }, [state.updateCodpro, state.changedTables])

  window.sugestions = () => {
    console.log(state.sugestions)
  }



  return (
    <>
      <DefaultModal dialogProps={{ maxWidth: 'xs' }} open={modalDelete} handleClose={closeModalDelete} content={<ModalText text={'Tem certeza que deseja deletar esta linha ?'} />} action={buttonConfirmDelete()}
        title={' Deletar linha '} />

      <DefaultModal dialogProps={{ maxWidth: 'xs' }} open={modalStatus} handleClose={closeModal} content={<ModalTransferRepresentative table={table} row={rowToTransfer} handleClose={closeModal} />}
        title={' Transferência de carga '} />

      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem', justifyContent: 'space-between' }} >

        <Box sx={{ flex: '0.8', display: 'flex', height: '28rem' }} >
          <DataGrid
            className='alterned_grid'
            rows={lines}
            columns={columnsMain}
            pagination={false}
            density='compact'
            pageSize={5}
            sx={{
              maxHeight: "30rem",
              '& .MuiDataGrid-columnHeaderTitleContainer': {
                justifyContent: 'center',
              }
            }}
            rowHeight={27}
          />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', flex: '0.2', justifyContent: 'flex-start', gap: '1rem' }}>

          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>

            <BoxInfo title={'Volume total (m³)'} value={m3} colorBack={'#c60000'} color={'white'} />

            <BoxTruckRepresentative title={'Volume do caminhão (m³)'} truck_size={truck_size} table={table} colorBack={'#c60000'} color={'white'} />

          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>

            <BoxInfo title={'Peso total (kg)'} value={peso} colorBack={'#c60000'} color={'white'} />

            <BoxInfo title={'Total de pneus'} value={envio} colorBack={'#c60000'} color={'white'} />

          </Box>

          {
            index !== trucks_number ?
              <></>
              :

              <MessageSend type={'representative'} hash={state.hash} />
          }


        </Box>

      </Box>
    </>
  )
}

export default DatagridRepresentative;